import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Learning.css";
import { AiFillSafetyCertificate } from "react-icons/ai";

export default function Learning() {
  return (
    <div>
      <Container className="learning-mas">
        <div>
          <h3>Learning for everyone</h3>
          <p>
            From skills-based training to deep learning, edX has the courses and
            programs your team needs.
          </p>
        </div>
        <Row>
          <Col lg={4} className="learn-card">
            <h5>
              <AiFillSafetyCertificate /> Verified Certificate Courses
            </h5>
            <p1>
              Over 30 in-demand subjects taught by experts with shareable and
              recognized certificates.
            </p1>
          </Col>
          <Col lg={4} className="learn-card">
            <h5>
              <AiFillSafetyCertificate /> Professional Certificates
            </h5>
            <p1>
              Develop and demonstrate mastery of job-relevant, critical business
              skills.
            </p1>
          </Col>
          <Col lg={4} className="learn-card">
            <h5>
              <AiFillSafetyCertificate /> Executive Education
            </h5>
            <p1>
              Develop critical executive skills in 2-6 weeks with affordable,
              in-demand online programs.
            </p1>
          </Col>
          <Col lg={4} className="learn-card">
            <h5>
              <AiFillSafetyCertificate /> MicroMasters® Programs
            </h5>
            <p1>
              Graduate level courses from top universities, providing deep
              learning in a specific career field and a path to a Master's
              Degree.
            </p1>
          </Col>
          <Col lg={4} className="learn-card">
            <h5>
              <AiFillSafetyCertificate /> Master's Degree Programs
            </h5>
            <p1>
              Offered in the most in-demand fields, from top-ranked
              institutions. Flexible, rigorous, and affordable programs that are
              industry recognized.
            </p1>
          </Col>
          <Col lg={4} className="learn-card">
            <h5>
              <AiFillSafetyCertificate /> MicroBachelors™ Programs
            </h5>
            <p1>
              Credit-backed, stackable credentials for adults with some or no
              college experience looking to progress their careers or pursue a
              bachelor’s degree.
            </p1>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
